<template>

  <div>

    <!-- contact_address -->
    <div class="mb-3">
      <label class="d-block text-uppercase text-muted small font-weight-bold mb-1">{{ $t('Contact') }}</label>
      <div v-if="editing">
        <select
          v-if="editing"
          :value="type"
          class="form-control form-control-sm mb-2"
          @change="$emit('update:type', $event.target.value)"
          placeholder="Select type">
          <option
            v-for="item in types"
            :key="item.value"
            :value="item.value">{{ $t(item.label) }}</option>
        </select>
        <input
          :value="value"
          type="text"
          class="form-control form-control-sm"
          :placeholder="placeholder"
          @input="$emit('update:value', $event.target.value)">
      </div>
      <div v-else>
        <ContactFieldRow
          v-if="value"
          :icon="icon"
          :value="value"
          :href="href" />
        <div
          v-else
          class="text-muted small py-1">{{ $t('No contact address') }}</div>
      </div>
    </div>

  </div>

</template>

<script>
import ContactFieldRow from './ContactFieldRow'

/*
contactAddressTypes
the channels a contact can be reached on. `label` is an i18n key, so it
must go through $t before being rendered.
*/
export const contactAddressTypes = [
  { value: 'whatsapp', label: 'WhatsApp', icon: 'fa-brands fa-whatsapp' },
  { value: 'sms', label: 'SMS', icon: 'fa-solid fa-comment-sms' },
  { value: 'email', label: 'Email', icon: 'fa-solid fa-envelope' }
]

export default {
  name: 'ContactAddressField',
  components: {
    ContactFieldRow
  },
  props: {
    type: {
      type: String,
      default: null
    },
    value: {
      type: String,
      default: ''
    },
    editing: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    types () {
      return contactAddressTypes
    },
    // generic card icon when the backend sends a type the frontend does not
    // know yet
    icon () {
      const definition = contactAddressTypes.find((item) => { return item.value === this.type })
      return definition ? definition.icon : 'fa-regular fa-address-card'
    },
    /*
    href
    the link used to open the contact address outside the app (whatsapp web, the
    mail client, the dialer); null when there is nothing sensible to open
    */
    href () {
      if (!this.value) {
        return null
      }

      if (this.type === 'email') {
        return 'mailto:' + this.value
      }
      // phone based channels: keep only digits so the link is valid
      const digits = this.value.replace(/[^0-9]/g, '')
      if (!digits) {
        return null
      }
      return this.type === 'whatsapp' ? 'https://wa.me/' + digits : 'tel:+' + digits
    },
    // e-mail channels get an address example, phone based ones the E.164 format
    placeholder () {
      return this.type === 'email' ? 'name@example.com' : '+5511990000000'
    }
  }
}
</script>

<style scoped>
.contact-address-icon {
  width: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/Messaging/contact/ContactAddressField.vue